module.exports = __webpack_public_path__ + "img/logoMonPermis.cf6e206d.png";